<div class="pme-container">
    <!-- <pme-window-shop-manager-header *ngIf="this.headerContent" [headerContent]="this.headerContent">
    </pme-window-shop-manager-header> -->

    <div class="product-listing-header" *ngIf="this.productListing" [innerHTML]="this.productListing.title"></div>

    <div class="display-utils-row display-utils-lt-md-col display-utils-center-center"
        *ngIf="stackingOnePackage && stackingOnePackageMessage">
        <div class="display-utils-gap-20 display-utils-center-center">
            <div class="warning-stacking-one-card">
                <div class="display-utils-row display-utils-center-center display-utils-gap-16 display-utils-sm-gap-8 display-utils-md-gap-16">
                    <img src="../../../assets/images/dialog-icons/warn-badge.svg">
                    <div class="display-utils-row display-utils-lt-sm-col display-utils-center-center display-utils-xs-start-start display-utils-gap-16 display-utils-xs-gap-4 display-utils-sm-gap-8 display-utils-md-gap-12">
                        <span>
                            <strong>Atenção</strong>
                        </span>
                        <p [innerHTML]="stackingOnePackageMessage"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!--PRODUCT LISTING-->
    <!--Desktop view-->
    <div class="display-utils-only-gt-sm"
        style="margin-top: 16px; margin-left: auto; margin-right: auto; width:100%;">
        <div class="display-utils-row display-utils-center-stretch display-utils-gap-24 products">

            <pme-consulta-product-selector [packages]="packages" [isCampaign]="true"
                (buyClicked)="navigatePackage($event.i, $event.customValue)">
            </pme-consulta-product-selector>
            <div class="campaign-wrapper" *ngIf="true">

                <div class="campaign-header-pink">
                    <div class="header-text">
                        <h2>Planos por Assinatura</h2>
                        <p>Pagamento mensal e mais economia</p>
                    </div>
                    <div class="header-badge">
                        <mat-icon class="badge-icon">percent</mat-icon>
                        <span>Opção com mais descontos</span>
                    </div>
                </div>

                <div class="plans-container display-utils-row display-utils-gap-16">
                    <pme-assinatura-product class="subscriberPlans display-utils-flex-1"
                        [ngClass]="{'start': i === 0, 'end': i === (plans.length -1)}" [plan]="assinatura"
                        [isCampaign]="true" *ngFor="let assinatura of plans; let i = index"
                        (buyClicked)="navigatePlan( i, $event)">
                    </pme-assinatura-product>
                </div>
            </div>
        </div>
    </div>
    <!-- end Desktop view -->

    <!--Mobile view -->
    <div class="display-utils-hide-gt-sm" style="margin-top: 16px;">
        <pme-switch-consulta-assinatura [selectedToggle]="selectedToggle"
            (onSelectionChanged)="onSelectionChanged($event)"></pme-switch-consulta-assinatura>
        <div class="productsMobile" *ngIf="selectedToggle === 0">
            <pme-packages-mobile [packages]="plans" [isPlan]="true" [campaign]="true"
                [activePlanIdentifier]="activePlanIdentifier" [activePlanValue]="activePlanValue"
                (buyClicked)="navigateMobile($event.i, $event.customValue)">
            </pme-packages-mobile>
        </div>
        <div class="productsMobile" *ngIf="selectedToggle === 1">
            <pme-packages-mobile [packages]="packages" [isPlan]="false" [campaign]="true"
                (buyClicked)="navigateMobile($event.i, $event.customValue)"></pme-packages-mobile>
        </div>
        <div *ngIf="this.productListing?.footer" [innerHTML]="this.productListing.footer"
            class="product-listing-footer">
        </div>
    </div>
    <!-- end Mobile view -->
    <div *ngIf="this.productListing" [innerHTML]="this.productListing.footer" class="product-listing-footer"></div>
    <!-- end Product Listing -->



    <!-- <mat-divider class="divider" *ngIf="this.tableNutritionContent"></mat-divider> -->

    <!-- <pme-window-shop-manager-nutrition-table *ngIf="this.tableNutritionContent"
    [tableNutritionContent]="this.tableNutritionContent"></pme-window-shop-manager-nutrition-table> -->

    <!-- <mat-divider class="divider"></mat-divider> -->
    <!-- <pme-window-shop-manager-nutrition-table *ngIf="this.tableNutritionContent"
        [tableNutritionContent]="this.tableNutritionContent"></pme-window-shop-manager-nutrition-table> -->
    <!-- <mat-divider class="divider" *ngIf="legalNotes?.length"></mat-divider>
    <div *ngIf="legalNotes?.length">
        <ul>
            <li *ngFor="let note of legalNotes" style="font-size: 14px; font-family: Roboto;">
                {{ note }}
            </li>
        </ul>
    </div> -->
    <mat-divider class="divider"></mat-divider>
    <pme-payment-methods></pme-payment-methods>
    <mat-divider class="divider"></mat-divider>
</div>
